import { OrderPlanningRowAction, OrderPlanningRowActionProps, ReasonMap } from "./OrderPlanningRowAction";
import { Button } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { Seating, SeatingEquipmentType } from "../../asset/Seating";

export class RowActionSeatTractor extends OrderPlanningRowAction {
    override getButton(): Button {
        return this.toolPanel.buttonSeatTractor;
    }

    override getButtonId(): string {
        return "buttonSeatTractor";
    }

    override getAdditionalProps() {
        return this.getFindNearAfterSlideoutProp();
    }

    override getFieldsUsedInThisFile(): string[] {
        return ["tractor", "move_status"];
    }

    override actionValidateSelection(selectedRows: ModelRow[], reasonMap: ReasonMap): void {
        const modelRow = selectedRows[0];
        if (modelRow.isNull("tractor")) {
            this.addReason(reasonMap, "missing_tractor", "Selected row does not have a tractor assigned.");
        }
        if (modelRow.get("move_status") === "P") {
            this.addReason(reasonMap, "in_progress_movement", "Cannot seat Tractor for In-Progress movements.");
        }
        return;
    }

    override execute(props: OrderPlanningRowActionProps) {
        const modelRow: ModelRow = props.selectedRows[0]?.data as ModelRow;
        if (modelRow == null)
            return;
        this.getButton().busy = true;
        Seating.showSlideout({
            equipmentId: modelRow.get("tractor"),
            equipmentType: SeatingEquipmentType.TRACTOR,
            forceMasterfileUpdate: true,
            doAfterSave: () => this.toolPanel.table?.selectedRow?.updateDataFromComponents(),
        }, { doAfterSlideOut: props.afterSlideout });
        this.getButton().busy = false;
    }
}
